import React from "react";
import { Chip, Paper, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styles from "./styles";

const useStyles = makeStyles(styles);

const DisplayUserLocations = ({ locations }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Paper component="ul" className={classes.chipPanel}>
      {(!locations || locations.length === 0) && (
        <Chip label={t("labels.common.none")} className={classes.chip} />
      )}
      {locations &&
        locations.length > 0 &&
        locations.map((l) => {
          return (
            <li key={l}>
              <Chip label={l} className={classes.chip} />
            </li>
          );
        })}
    </Paper>
  );
};

export default React.memo(DisplayUserLocations);
